import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import { navigate } from '../../../../store/pages';
import { openDialog } from '../../../../store/dialogs';
import useLogger from '../../../../store/hooks/useLogger';
import useLoggerDevices from '../../../../store/hooks/useLoggerDevices';
import LoggerProfileChart from '../../../../components/charts/preview/LoggerProfileChart';
import AlarmPreviewLink from '../../../../components/AlarmPreviewLink';
import LoggerInactiveCard from '../../../../components/LoggerInactiveCard';

function LoggerCard({ orgId, loggerId, timezone }) {
  const dispatch = useDispatch();
  const { alarms } = useLoggerDevices(loggerId);
  const logger = useLogger(loggerId);

  const handleLoggerClick = () => {
    dispatch(navigate({ page: 'logger', id: loggerId }));
  };

  const handleIconClick = () => {
    dispatch(
      openDialog({
        type: 'logger',
        mode: 'edit',
        id: loggerId,
      })
    );
  };

  const activeAlarms = filter(alarms, { status: true });
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        backgroundImage: (theme) => theme.vars.overlays[8],
        boxShadow: (theme) => theme.shadows[4],
        borderRadius: 1,
        px: 1,
        pt: 1,
        pb: 0.5,
        width: '100%',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <AlarmPreviewLink
          alarms={activeAlarms}
          deviceName={logger.name}
          handleClick={() => handleLoggerClick()}
        />
        <IconButton onClick={() => handleIconClick()}>
          <FontAwesomeIcon icon={['fal', 'cog']} size='sm' />
        </IconButton>
      </Box>
      {logger.active ? (
        <LoggerProfileChart
          orgId={orgId}
          loggerId={loggerId}
          timezone={timezone}
        />
      ) : (
        <LoggerInactiveCard deviceName={logger.name} />
      )}
    </Box>
  );
}

LoggerCard.propTypes = {
  orgId: PropTypes.string.isRequired,
  loggerId: PropTypes.string.isRequired,
  timezone: PropTypes.object.isRequired,
};

export default LoggerCard;
